const InvoiceSection = ({ label, value }) => (
    <div className="container mx-auto py-1 px-10 flex flex-wrap flex-col sm:flex-row">
      <p className="text-black font-semibold text-sm text-center sm:text-left">{label}</p>
      <span className="text-black font-semibold inline-flex sm:ml-auto sm:mt-0 mt-2 justify-center sm:justify-start">
        {value}
      </span>
    </div>
  );

export default InvoiceSection;